import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginCard from '../components/auth/LoginCard';

/* /login — standalone full page showing the SAME design as the header login popup
   (via the shared <LoginCard/>) on the reddy dark backdrop. Real backend login.
   Wrapped in .reddy-home so the scoped .login-popup / .login-block CSS applies even
   though this route is outside ReddyLayout (isAuthRoute → no header chrome). */
export default function LoginPage({ setUser }) {
  const navigate = useNavigate();
  return (
    <div className="reddy-home login-page-standalone">
      <div className="login-popup login-page-card">
        <div className="modal-content">
          <div className="modal-body">
            <LoginCard onSuccess={() => navigate('/')} setUser={setUser} />
          </div>
        </div>
      </div>
    </div>
  );
}
